import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';

const imageCache = {};
const VehicleInventoryImage = React.memo(function VehicleInventoryImage({
  src,
  alt,
  onError,
}: {
  src: string;
  alt: string;
  onError: any;
}) {
  const [loadedSrc, setLoadedSrc] = useState(imageCache[src] ? src : '');
  const isMounted = useRef(true);

  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);

  useEffect(() => {
    if (!imageCache[src]) {
      const img = new Image();
      img.src = src;
      img.onload = () => {
        imageCache[src] = true;
        if (isMounted.current) {
          setLoadedSrc(src);
        }
      };
    }
  }, [src]);

  return (
    <CustomImage
      src={loadedSrc}
      alt={alt}
      onError={onError}
      data-testid='vehicle-inventory-image'
    />
  );
});

const CustomImage = styled.img`
  vertical-align: middle;
  position: absolute;
  top: -50%;
  bottom: -50%;
  margin: auto;
  width: 100%;
  height: auto;
`;

export default VehicleInventoryImage;
